import { render, staticRenderFns } from "./WxjkBenefit.vue?vue&type=template&id=3f4502d2&scoped=true&"
import script from "./WxjkBenefit.vue?vue&type=script&lang=js&"
export * from "./WxjkBenefit.vue?vue&type=script&lang=js&"
import style0 from "./WxjkBenefit.vue?vue&type=style&index=0&id=3f4502d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4502d2",
  null
  
)

export default component.exports